import Container from "react-bootstrap/Container";
import FormSection from "../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../components/Faq";
import "../styles/dualEducation.css";
import "../styles/sliderCalculator.css";
import ResultsSection from "../components/ResultSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function ElmaradottTersegBruhazas() {
  const [projectCost, setProjectCost] = useState(10); // in million Ft

  const grantAmount = projectCost * 0.5;
  const ownResouce = projectCost * 0.5;

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">GINOP Plusz-1.2.4-24</span>

        <h1 className="title">
          Támogatás a leghátrányosabb{" "}
          <span style={{ color: "#c7d2fe" }}>helyzetű régiókban</span>
        </h1>

        <p className="subtitle">
          Vissza nem térítendő támogatás vidéki mikro- és kisvállalkozásoknak
          technológiai fejlesztésre és ingatlan beruházásra.{" "}
          <strong>50%-os támogatási intenzitás</strong>, akár{" "}
          <strong>120 millió Ft</strong> elnyerhető összeg.
          <br />
          <span className="fw-bold">
            Számold ki, mekkora támogatásra jogosult vállalkozásod!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Számolok
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Kérdésem van!
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-3">
            <Col md={3}>
              <Card className="card">
                <div className="kpi">50% Intenzitás</div>
                <div className="muted">Vissza nem térítendő támogatás</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">5-120 M Ft</div>
                <div className="muted">Elnyerhető támogatási összeg</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">50% Előleg</div>
                <div className="muted">Azonnali likviditás a kezdéshez</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">SZVZ</div>
                <div className="muted">Szabad Vállalkozási Zónákban is</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="tevekenysegek" className="section">
          <h2 className="h2">Támogatható tevékenységek</h2>
          <p className="lead">
            A pályázat célja a vállalkozások modernizációja, új eszközök
            beszerzése és az ingatlanállomány fejlesztése.
          </p>

          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Kötelező elemek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Eszközbeszerzés:</strong> Új eszközök, gépek
                    beszerzése (min. a projekt 30%-a)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Szakmai megvalósítás:</strong> Projektmenedzsment,
                    tanácsadás, rezsi, készlet (fix 7%)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Nyilvánosság:</strong> Kötelező tájékoztatás és
                    horizontális tevékenységek
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Választható elemek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Ingatlan beruházás:</strong> Építés, korszerűsítés,
                    bővítés (fajlagos költségek szerint)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>IT fejlesztés:</strong> Szoftverek, hardverek,
                    felhőszolgáltatások (max. 50%)
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="mt-2" />
                    <strong>Modernizáció:</strong> Új technológiai rendszerek és
                    kapacitások kialakítása
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Kalkulátor – Tervezd meg a beruházást!</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Tervezett beruházás összege:{" "}
                <span className="number">{projectCost}</span> millió Ft
              </h3>

              <input
                type="range"
                min={10}
                max={240}
                step={5}
                value={projectCost}
                onChange={(e) => setProjectCost(Number(e.target.value))}
                className="slider"
              />

              <div className="revenue-block">
                <div className="row">
                  <Col md={6}>
                    <div className="revenue-text">Várható támogatás (50%):</div>
                    <div className="revenue-value">
                      <strong>{grantAmount.toFixed(1)} millió Ft</strong>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="revenue-text">Szükséges önerő (50%):</div>
                    <div className="revenue-value" style={{ color: "#c7d2fe" }}>
                      <strong>{ownResouce.toFixed(1)} millió Ft</strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *A támogatás vissza nem térítendő. Az igényelhető összeg 5 és
                  120 millió Ft között mozoghat.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Ingyenes előminősítést kérek!
              </Button>
            </div>
          </section>
        </Container>

        <section id="jogosultsag" className="section">
          <h2 className="h2">Kik pályázhatnak?</h2>
          <p className="lead">
            A támogatás a leghátrányosabb helyzetű régiókban vagy SZVZ
            településeken működő mikro- és kisvállalkozásoknak szól.
          </p>
          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Jogosultsági feltételek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Dél-Alföld, Dél-Dunántúl, Észak-Alföld, Észak-Magyarország
                    vagy SZVZ település
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Legalább 1 lezárt teljes üzleti év
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Minimum 1 fős átlagos statisztikai létszám
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Magyarországi székhely és kettős/egyszeres könyvvezetés
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Legalább 180 napja bejegyzett helyszín
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Kizáró okok</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Budapesti megvalósítási helyszín
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    KATA hatálya alá tartozó vállalkozás
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Mezőgazdasági vagy élelmiszeripari főtevékenység (bizonyos
                    esetekben)
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérj ingyenes előminősítést</h2>
          <p className="lead small">
            Vizsgáltasd be cégedet díjmentesen, és tudd meg 24 órán belül a
            lehetőségeidet!
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Hátrányos helyzetű régiók (GINOP 1.2.4)" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>50% vissza nem térítendő támogatás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>50% előleg a projekt megkezdéséhez</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Eszközbeszerzés és ingatlanfejlesztés egyben</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes előminősítés és tanácsadás</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <Container>
          <h2 className="h2">Eredményeink számokban</h2>
          <ResultsSection />
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Milyen régiókban kell megvalósítani a projektet?",
                    answer:
                      "A négy célrégió: Dél-Alföld, Dél-Dunántúl, Észak-Alföld és Észak-Magyarország. Emellett az ország bármely részén található Szabad Vállalkozási Zóna (SZVZ) települései is támogatottak, kivéve Budapestet.",
                  },
                  {
                    question: "Kapható előleg a projekthez?",
                    answer:
                      "Igen, a megítélt támogatás 50%-a kérhető előlegként, ami jelentős segítséget nyújt a beruházás elindításához.",
                  },
                  {
                    question: "Mikor lehet benyújtani a pályázatot?",
                    answer:
                      "A tervezett benyújtási időszak 2025. augusztus 5. és 2026. április 30. között van. Fontos tudni, hogy a keret kimerülése esetén a kiírást hamarabb is felfüggeszthetik.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
